import { stringFormat } from "./utils";

class TitleElementUpdater {
  private originalText: string;
  private element: HTMLElement;
  private spotsRemaining: number;
  private totalVotesCast: number;
  private showTotal: boolean;
  private maxVotes: number;

  constructor(id: string, showTotal: boolean = false) {
    let element = document.getElementById(id);
    if (!element) throw new Error("Couldn't find " + id);
    this.element = element;
    this.originalText = element.innerHTML;
    this.spotsRemaining = 100;
    this.totalVotesCast = 0;
    this.showTotal = showTotal
    this.maxVotes = 0;
  }

  onMaxVotesAvailable(maxVotes: number) {
    this.maxVotes = maxVotes;
    this.updateText();
  }

  onSpotsRemainingChanged(spotsRemaining: number) {
    this.spotsRemaining = spotsRemaining;
    this.updateText();
  }

  onTotalVotesCastChanged(totalVotesCast: number) {
    this.totalVotesCast = totalVotesCast;
    if (this.totalVotesCast > 0) {
      if (this.showTotal) {
        this.originalText =
          "There are {0} out of {1} whitelist spots left. <b>You have already claimed {2}.</b> How many more do you want to claim?";
      } else {
        this.originalText =
          "There are {0} whitelist spots left. <b>You have already claimed {2}.</b> How many more do you want to claim?";
      }
      this.updateText();
    }
  }

  updateText() {
    this.element.innerHTML = stringFormat(
      this.originalText,      
      this.spotsRemaining,      
      this.maxVotes,
      this.totalVotesCast
    );
  }
}

class CostElementUpdater {
  originalText: string;
  element: HTMLElement;

  constructor(id: string) {
    let element = document.getElementById(id);
    if (!element) throw new Error("Couldn't find " + id);
    this.element = element;
    this.originalText = element.innerHTML;
  }

  updateText(newText: string) {
    this.element.innerHTML = stringFormat(this.originalText, newText);
  }
}

export { TitleElementUpdater, CostElementUpdater };
